<template>
  <!-- note: these classes have been copied from RevContentBlock. see containerClassNames for imageLeft: false -->
  <div class="flex flex-col md:flex-row md:items-center">
    <!-- note: these classes have been copied from RevContentBlock. see contentClassNames for imageLeft: false -->
    <div
      class="order-2 mb-32 flex flex-col justify-center md:order-1 md:mb-0 md:mr-56"
    >
      <h1
        :id="textToTarget(title, 'heading-1')"
        class="text-static-default-hi heading-1 md:punchline"
      >
        {{ title }}
      </h1>

      <div v-if="description" class="text-static-default-low body-1 mt-20">
        {{ description }}
      </div>

      <div class="mt-32 hidden md:block">
        <DiscountCTA
          :ctaLabel
          :discountType
          :secondaryCtaLabel
          :tracking="trackingData"
        />
      </div>
    </div>

    <!-- note: these classes have been copied from RevContentBlock. see illustrationWrapperClassNames for imageLeft: false -->
    <div
      class="order-1 mb-32 min-w-[40%] flex-initial items-center justify-center md:mb-0 md:ml-auto md:w-448 md:min-w-448"
    >
      <!-- see illustrationClassNames from RevContentBlock -->
      <RevIllustration
        v-bind="image"
        :alt="image.alt || ''"
        class="rounded-lg w-full overflow-hidden"
      />
    </div>

    <div class="order-2 md:!hidden">
      <DiscountCTA
        :ctaLabel
        :discountType
        :secondaryCtaLabel
        :tracking="trackingData"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { DiscountBannerApiProps } from '@backmarket/http-api/src/api-specs-content/models/discount-banner'
import { RevIllustration } from '@ds/components/Illustration'

import type { BlockProps } from '@backmarket/nuxt-layer-cms/models/content-block'

import { textToTarget } from '../../utils/textToTarget'

import DiscountCTA from './DiscountCTA.vue'

export type DiscountBannerBlockProps = DiscountBannerApiProps & BlockProps
const props = defineProps<DiscountBannerBlockProps>()

// This event is common to every CMS block in order to hide the block containers
// on demand
defineEmits(['error'])

const trackingData = {
  ...props.tracking,
}
</script>
